export const GET_INVOICES_ORDERS_EDIT = 'providers/invoicing/InvoicesTicketsEditorProvider/GET_INVOICES_ORDERS_EDIT';
export const GET_INVOICES_ORDERS_EDIT_BY_PAGINATION =
  'providers/invoicing/InvoicesTicketsEditorProvider/GET_INVOICES_ORDERS_EDIT_BY_PAGINATION';
export const GET_INVOICES_ORDERS_PRE_EDIT =
  'providers/invoicing/InvoicesTicketsEditorProvider/GET_INVOICES_ORDERS_PRE_EDIT';
export const UPDATE_INVOICES_ORDERS = 'providers/invoicing/InvoicesTicketsEditorProvider/UPDATE_INVOICES_ORDERS';
export const RESET_EDITED_INVOICES_ORDERS =
  'providers/invoicing/InvoicesTicketsEditorProvider/RESET_EDITED_INVOICES_ORDERS';
export const GENERATE_INVOICING = 'providers/invoicing/InvoicesTicketsEditorProvider/GENERATE_INVOICING';

export const GET_INVOICES_ORDER_DETAILS_EDIT =
  'providers/invoicing/InvoicesTicketsEditorProvider/GET_INVOICES_ORDER_DETAILS_EDIT';
export const UPDATE_ORDER_REMOVE_ITEM = 'providers/invoicing/InvoicesTicketsEditorProvider/UPDATE_ORDER_REMOVE_ITEM';
export const UPDATE_ORDER_DISCOUNT = 'providers/invoicing/InvoicesTicketsEditorProvider/UPDATE_ORDER_DISCOUNT';
export const REVERT_CHANGES_ORDER_EDITED =
  'providers/invoicing/InvoicesTicketsEditorProvider/REVERT_CHANGES_ORDER_EDITED';
export const SAVE_CHANGES_ORDER_EDITED = 'providers/invoicing/InvoicesTicketsEditorProvider/SAVE_CHANGES_ORDER_EDITED';
